import { RateioDespesas } from './RateioDespesas';
import { SaldoAdiantamento } from './SaldoAdiantamento';
import { ImagemNotaFiscal } from './ImagemNotaFiscal';

export class DocumentoPreEditado {
    idProtocolo: number;
    valor: number;
    dataEmissaoNf?: Date;
    dataEmissaoNfExibicao: string;
    dataVencimentoNf?: Date;
    dataVencimentoNfExibicao: string;
    idTipoDocumento: number;
    descTipoDocumento: string;
    tipoDocumentoSap: string;
    idStatusProtocolo: number;
    idStatusNovo: number;
    status: string;
    dataHoraCriacao: Date;
    loginUsuarioCriacao: string;
    loginUsuarioResponsavel: string;
    emailUsuarioResponsavel: string;
    dataHoraAlteracao: Date;
    loginUsuarioUltAlteracao: string;
    nomeFornecedor: string;
    loginResponsavel: string;
    cnpjfornecedor: string;
    cpffornecedor: string;
    cnpjDestinatario: string;
    nomeEmpresa: string;
    loginAprovador: string;
    observacao: string;
    quantidadeRateio: number;
    condicaoPagamento: string;
    parcelado: boolean;
    codDespesa: string;
    idSapFornecedor: string;
    codBarras: string;
    idDivisao: number;
    divisao: string;
    codEmpresa: string;
    rateios: RateioDespesas[];
    adiantamentos?: SaldoAdiantamento[];
    imagensNotaFiscal: ImagemNotaFiscal[];
    confirmarEnvio: boolean;
    documento: string;
    eventoDuplicado: string;
    dataHoraCriacaoExibicao: string;
    notaFiscal: string;
    serieNotaFiscal: string;
    naoFiscal?: number;
    justificativa: string;
    dataCriacaoNfExibicao: string;
}
